export default "__VITE_ASSET__CoVmMhLV__"